<mat-expansion-panel [expanded]="!userControlledAccordion && !addressReady" (opened)="onAccordionToggle()" (closed)="onAccordionToggle()">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon [ngClass]="addressSectionClass()">{{addressSectionIcon()}}</mat-icon>
      <span i18n="@@Delivery address">Delivery address</span>
    </mat-panel-title>
    <mat-panel-description *ngIf="addressReady && cart.address">
      {{cart.address.firstname}} {{cart.address.lastname}}, {{cart.address.address1}}, {{cart.address.city}}, {{cart.address.state}} {{cart.address.postalcode}}
    </mat-panel-description>
    <mat-panel-description *ngIf="!addressReady" class="section-hint">
      <span i18n="@@Select or enter an address">Select or enter an address</span>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <div class="errorMessage" *ngIf="cart.deliveryAddressErrorMessage.length > 0">
    <h3 color="warn">{{cart.deliveryAddressErrorMessage}}</h3>
  </div>

  <!-- Saved addresses -->
  <div *ngIf="addresses && addresses.length > 0 && !editDeliveryAddress">
    <mat-radio-group class="radio-group" (change)="selectSavedAddress($event.value)">
      <mat-radio-button class="checkout-address-option" *ngFor="let address of addresses" [checked]="address.ID == cart.address.ID" [value]="address">
        <div class="checkout-address-block">
          <div><ng-container *ngIf="address.firstname">{{address.firstname}}&nbsp;</ng-container><ng-container *ngIf="address.lastname">{{address.lastname}}</ng-container></div>
          <div *ngIf="address.company">{{address.company}}</div>
          <div><ng-container *ngIf="address.address1">{{address.address1}}</ng-container><ng-container *ngIf="address.address2">,&nbsp;{{address.address2}}</ng-container></div>
          <div><ng-container *ngIf="address.city">{{address.city}}</ng-container><ng-container *ngIf="address.state">,&nbsp;{{address.state}}</ng-container><ng-container *ngIf="address.postalcode">&nbsp;{{address.postalcode}}</ng-container><ng-container *ngIf="address.country">&nbsp;{{address.country}}</ng-container></div>
          <mat-icon *ngIf="address.default" class="default-badge">favorite</mat-icon>
        </div>
        <button mat-icon-button (click)="startEditingSavedAddress(address)"><mat-icon>edit</mat-icon></button>
        <button mat-icon-button (click)="deleteSavedDeliveryAddress(address)"><mat-icon>delete</mat-icon></button>
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <button *ngIf="!editDeliveryAddress" mat-button color="primary" (click)="startEditingNewAddress()"><ng-container i18n="@@Add address">Add address</ng-container></button>

  <!-- Address form -->
  <form class="checkout-form" *ngIf="editDeliveryAddress">
    <div class="checkout-form-row">
      <mat-form-field appearance="outline" class="checkout-field">
        <mat-label i18n="@@First Name">First Name</mat-label>
        <input matInput [(ngModel)]="cart.address.firstname" (change)="onFieldChange()" required [ngModelOptions]="{standalone: true}"/>
      </mat-form-field>
      <mat-form-field appearance="outline" class="checkout-field">
        <mat-label i18n="@@Last Name">Last Name</mat-label>
        <input matInput [(ngModel)]="cart.address.lastname" (change)="onFieldChange()" required [ngModelOptions]="{standalone: true}"/>
      </mat-form-field>
    </div>
    <mat-form-field appearance="outline" class="checkout-field-full">
      <mat-label i18n="@@Company">Company</mat-label>
      <input matInput [(ngModel)]="cart.address.company" (change)="onMetadataFieldChange()" [ngModelOptions]="{standalone: true}"/>
    </mat-form-field>
    <mat-form-field appearance="outline" class="checkout-field-full">
      <mat-label i18n="@@Street Address">Street Address</mat-label>
      <input matInput [(ngModel)]="cart.address.address1" (change)="onFieldChange()" required [ngModelOptions]="{standalone: true}"/>
    </mat-form-field>
    <mat-form-field appearance="outline" class="checkout-field-full">
      <mat-label i18n="@@Apt/Suite">Apt/Suite</mat-label>
      <input matInput [(ngModel)]="cart.address.address2" (change)="onFieldChange()" [ngModelOptions]="{standalone: true}"/>
    </mat-form-field>
    <div class="checkout-form-row">
      <mat-form-field appearance="outline" class="checkout-field">
        <mat-label i18n="@@City">City</mat-label>
        <input matInput [(ngModel)]="cart.address.city" (change)="onFieldChange()" required [ngModelOptions]="{standalone: true}"/>
      </mat-form-field>
      <mat-form-field appearance="outline" class="checkout-field-sm">
        <mat-label i18n="@@State">State</mat-label>
        <mat-select [(ngModel)]="cart.address.state" (selectionChange)="onFieldChange()" required [ngModelOptions]="{standalone: true}">
          <mat-option value="" disabled i18n="@@Please select a state, provence or region">Please select a state, provence or region</mat-option>
          <mat-option *ngFor="let s of usStates" [value]="s.code">{{s.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="checkout-field-sm">
        <mat-label i18n="@@Zip Code">Zip Code</mat-label>
        <input matInput [(ngModel)]="cart.address.postalcode" (change)="onFieldChange()" required [ngModelOptions]="{standalone: true}"/>
      </mat-form-field>
    </div>
    <mat-form-field appearance="outline" class="checkout-field-full">
      <mat-label i18n="@@Country">Country</mat-label>
      <mat-select [(ngModel)]="cart.address.country" (selectionChange)="onFieldChange()" required [ngModelOptions]="{standalone: true}">
        <mat-option *ngFor="let c of countries" [value]="c.code">{{c.name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="checkout-field-full">
      <mat-label i18n="@@Email">Email</mat-label>
      <input matInput [(ngModel)]="cart.address.email" (change)="onFieldChange()" required [ngModelOptions]="{standalone: true}"/>
    </mat-form-field>
    <div class="checkout-form-row">
      <mat-form-field appearance="outline" class="checkout-field">
        <mat-label i18n="@@Purchase Order">Purchase Order</mat-label>
        <input matInput [(ngModel)]="cart.purchaseOrder" (change)="onMetadataFieldChange()" [ngModelOptions]="{standalone: true}"/>
      </mat-form-field>
      <mat-form-field appearance="outline" class="checkout-field">
        <mat-label i18n="@@Private Purchase Order">Private Purchase Order</mat-label>
        <input matInput [(ngModel)]="cart.purchaseOrderPrivate" (change)="onMetadataFieldChange()" [ngModelOptions]="{standalone: true}"/>
      </mat-form-field>
    </div>
    <div class="checkout-form-actions">
      <mat-slide-toggle color="primary" [(ngModel)]="cart.address.default" (change)="makeAddressDefault(cart.address); onMetadataFieldChange()" [ngModelOptions]="{standalone: true}">
        <ng-container i18n="@@Make this my default address">Make this my default address</ng-container>
      </mat-slide-toggle>
      <span class="checkout-form-btns">
        <button mat-icon-button [disabled]="!deliveryAddressChanged" (click)="saveChangesToDeliveryAddress(cart.address); cancelEditing()"><mat-icon>save</mat-icon></button>
        <button mat-icon-button (click)="cancelEditing()"><mat-icon>cancel</mat-icon></button>
      </span>
    </div>
    <!--
      Payee / Inventory Type are ServiceProvider- and Network-only
      choices. An ordinary Organization always pays for its own order
      and always prints to order, so the controls are hidden and the
      cart is normalized to those defaults (see
      `normalizeFulfillmentOptions()`).
    -->
    <ng-container *ngIf="canChooseFulfillmentOptions">
      <div class="checkout-form-row">
        <mat-form-field appearance="outline" class="checkout-field">
          <mat-label i18n="@@Payee">Payee</mat-label>
          <mat-select [(ngModel)]="cart.payer" (selectionChange)="onPayerOrInventoryTypeChange()" [ngModelOptions]="{standalone: true}">
            <mat-option value="ORGANIZATION" i18n="@@Organization">Organization</mat-option>
            <mat-option value="REQUEST_NETWORK_REPLACEMENT" i18n="@@Request Replacement">Request Replacement</mat-option>
            <mat-option value="SERVICE_PROVIDER_REPLACEMENT" i18n="@@Service Provider Replacement">Service Provider Replacement</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="checkout-field">
          <mat-label i18n="@@Inventory Type">Inventory Type</mat-label>
          <mat-select [(ngModel)]="cart.inventoryType" (selectionChange)="onPayerOrInventoryTypeChange()" [ngModelOptions]="{standalone: true}">
            <mat-option value="FULFILL_FROM_INVENTORY" i18n="@@Fulfill From Inventory">Fulfill From Inventory</mat-option>
            <mat-option value="PRINT_TO_ORDER" i18n="@@Print To Order">Print To Order</mat-option>
            <mat-option value="REPLENISH_INVENTORY" i18n="@@Replenish Inventory">Replenish Inventory</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-container>
    <!-- Address validation -->
    <div class="checkout-address-validation">
      <p *ngIf="cart.addressValidationStatus==='INITIAL'" i18n="@@Validate address">Validate address</p>
      <div *ngIf="cart.addressValidationStatus==='SUCCESS'" class="checkout-validated-address">
        <p i18n="@@Suggested Validated Address">Suggested Validated Address</p>
        <p>{{validatedAddress.address1}}<span *ngIf="validatedAddress.address2">&nbsp;{{validatedAddress.address2}}</span></p>
        <p>{{validatedAddress.city}},&nbsp;{{validatedAddress.state}}&nbsp;{{validatedAddress.postalcode}}&nbsp;{{validatedAddress.country}}</p>
      </div>
      <div *ngIf="cart.addressValidationStatus === 'NO VALID SUGGESTIONS'">
        <p i18n="@@No address suggestions">No address suggestions</p>
        <p i18n="@@Update address values and re-validate">Update address values and re-validate</p>
      </div>
      <!-- Not verdicts about the address: one is a failed call, the other a
           country the validator does not cover. Telling the customer to correct
           and re-validate in either case sends them round a loop that cannot
           terminate. -->
      <div *ngIf="cart.addressValidationStatus === 'VALIDATION_ERROR'">
        <p i18n="@@The address validation request did not complete, so this address has not been checked">The address validation request did not complete, so this address has not been checked</p>
      </div>
      <div *ngIf="cart.addressValidationStatus === 'VALIDATION_UNAVAILABLE'">
        <p i18n="@@Address validation is not available for this country, so this address cannot be checked">Address validation is not available for this country, so this address cannot be checked</p>
      </div>
      <div class="checkout-validation-btns">
        <button *ngIf="cart.addressValidationStatus==='SUCCESS' && cart.addressValidationStatus !== 'VALIDATED'" mat-raised-button color="primary" (click)="applyValidatedAddress()" i18n="@@Use this validated address">Use this validated address</button>
        <button *ngIf="cart.addressValidationStatus !== 'INITIAL' && cart.addressValidationStatus !== 'MANUAL_OVERRIDE'" mat-raised-button color="warn" (click)="overrideAddressValidation()" i18n="@@Use entered address">Use entered address</button>
        <button mat-raised-button [color]="cart.addressValidationStatus==='SUCCESS' ? 'accent' : 'primary'" (click)="validateAndCheck()" i18n="@@Validate address">Validate address</button>
      </div>
    </div>
  </form>
  <!-- Phase 4: prompt to persist a freshly-entered address to the address book -->
  <div class="checkout-save-address-prompt" *ngIf="shouldOfferToSaveAddress()">
    <mat-icon>bookmark_add</mat-icon>
    <span i18n="@@Save this address to your address book?">Save this address to your address book?</span>
    <button mat-button color="primary" (click)="saveCurrentAddressToBook()" i18n="@@Save">Save</button>
  </div>
</mat-expansion-panel>
